import styled from '../../config/theme'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  margin-bottom: 0;
  flex: 1;
`

export {
  Container,
}
